<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    isEnabled.value = !!currentAccount.value?.auto_assign_teams_on_transfer;
  },
  { deep: true, immediate: true }
);

const toggleAutoAssignTeams = async () => {
  try {
    await updateAccount({
      auto_assign_teams_on_transfer: isEnabled.value,
    });
    useAlert(t('GENERAL_SETTINGS.UPDATE.SUCCESS'));
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.UPDATE.ERROR'));
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.AUTO_ASSIGN_TEAMS.LABEL')"
    :description="t('GENERAL_SETTINGS.AUTO_ASSIGN_TEAMS.DESCRIPTION')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleAutoAssignTeams" />
      </div>
    </template>
  </SectionLayout>
</template>
